import React from 'react';
import Text from '../Text';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    classNoResults: {
        backgroundColor: Tokens.colorBrandNeutral200,
        color: Tokens.colorTextDisabled,
        fontSize: Tokens.fontSizeHeader4
    },
    classSecondaryMessage: {
        color: Tokens.colorBrandNeutral400
    }
});
const MessageStyled = (props) => {
    const { classes, classMessage, message } = props;
    let newClassMessage;
    let ssTextProps = {};
    if (classMessage === 'noResults') {
        newClassMessage = classes.classNoResults;
        ssTextProps = {
            className: newClassMessage,
            size: 'large'
        };
    }
    if (classMessage === 'pageInstructions') {
        ssTextProps = {
            align: 'center',
            size: 'large'
        };
    }
    if (classMessage === 'secondaryMessage') {
        newClassMessage = classes.classSecondaryMessage;
        ssTextProps = {
            size: 'small'
        };
    }
    return (React.createElement(Text, Object.assign({}, ssTextProps), message));
};
export default withStyles(styles)(MessageStyled);
